export class User {
  id: string = '';
  username: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  emailVerified: boolean = false;
  enabled: boolean = false;
  realmRoles: Role[] = [];
  clientRoles: string[] = [];
  credentials: UserCredentials[] | null = null;
}

export class UserCredentials {
  id: string = '';
  type: string = 'password';
  value: string = '';
  temporary: boolean = false;
}

export class Role {
  id: string = '';
  name: string = '';
  description: string = '';
}

export class EditUserRequest {
  realm: string = '';
  user: User = new User();

  constructor(realm: string, user: User) {
    this.realm = realm;
    this.user = user;
  }
}

export class UserRealmIdRequest {
  realm: string = '';
  id: string = '';

  constructor(realm: string, id: string) {
    this.realm = realm;
    this.id = id;
  }
}

export class ResetUserPasswordRequest {
  realm: string = '';
  id: string = '';
  data: UserCredentials;

  constructor(realm: string, id: string, data: UserCredentials) {
    this.realm = realm;
    this.id = id;
    this.data = data;
  }
}

export class ArchivUser {
  id: number = 0;
  username: string = '';
  //userpasswort: string = '';
  benutzername: string = '';
  beschreibung: string = '';
  email: string = '';
  telefon: string = '';
  info: string = '';
  aktiv: number | null = null;
  //supervisor: number | null = null;
  multilogin: number | null = null;
  changepasswort: number | null = null;

  passwortgueltig: Date | null = null;

  loginfehler: number | null = null;
  chipkarte: Uint8Array = new Uint8Array();
  canchangepasswort: number | null = null;
  guid: string = '';
  domainusername: string = '';
}

export class MergeUserRequest {
  unternehmenId: number;
  user: ArchivUser;

  constructor(unternehmenId: number, user: ArchivUser) {
    this.unternehmenId = unternehmenId;
    this.user = user;
  }
}

export class ImportUserRequest {
  unternehmenId: number;
  archivUserId: number;
  user: User;

  constructor(unternehmenId: number, archivUserId: number, user: User) {
    this.unternehmenId = unternehmenId;
    this.archivUserId = archivUserId;
    this.user = user;
  }
}
